@if (category) {
  <div class="container single-view" id="edit-category">
    <div class="row">
      <div class="col-12 mb-6 flex flex-wrap items-end justify-between gap-4">
        <div id="pre-header-wr">
          <a data-testid="back-btn" appBack [fallbackUrl]="'/categories/' + categoryId" class="inline-flex items-center text-base link link-icon left-arrow">{{ 'CATEGORIES.BTN_BACK_TO_CATEGORY' | translate }}</a>
        </div>
      </div>
      <div class="col-12">
        <div id="view-header-wr">
          <div class="title-wr">
            <h1 data-testid="edit-category-title" class="section-title">{{ 'CATEGORY_UPDATE.TITLE' | translate }}</h1>
          </div>
        </div>
        <hr role="presentation" class="w-full mb-3 mt-6 border-t">
        <div class="view-content-wr">
          <div class="row">
            <div class="flex flex-col col-12 mb-2 text-wr">
              <!-- main content -->
              <form class="mt-0" [formGroup]="categoryForm" data-testid="edit-category-form">
                <div class="row">
                  <div class="flex flex-col col-12 mb-4">
                    <h2 data-testid="edit-category-details-title" class="border-b pb-3">{{ 'CATEGORY_UPDATE.CATEGORY_DETAILS' | translate }}</h2>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-category-field-name" class="block text-sm" for="name">{{ 'CATEGORY_UPDATE.NAME' | translate }} <i class="icon-required-field"></i></label>
                    <input data-testid="edit-category-name-input" type="text" formControlName="name" autocomplete="off">
                    @if (categoryForm.get('name')?.invalid && categoryForm.get('name')?.touched) {
                      <small data-testid="name-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-category-field-code"  class="block text-sm" for="code">{{ 'CATEGORY_UPDATE.CODE' | translate }} <i class="icon-required-field"></i></label>
                    <input data-testid="edit-category-code-input" type="text" formControlName="code" autocomplete="off">
                    @if (categoryForm.get('code')?.invalid && categoryForm.get('code')?.touched) {
                      <small data-testid="code-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                  <div class="field-wr col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3">
                    <label data-testid="edit-category-field-hasParent" class="block text-sm mb-3" for="hasParent">{{ 'CATEGORY_UPDATE.HAS_PARENT' | translate }}</label>
                    <span class="inline-flex mr-6">
                      <label for="yes" data-testid="edit-category-has-parent-yes-label" class="inline-flex items-center cursor-pointer">
                        <p-radioButton data-testid="edit-category-has-parent-yes" name="hasParentCategory" value="true" formControlName="hasParentCategory" inputId="yes" />
                        <span for="yes" class="ml-2">{{ 'BOOLEANS.YES' | translate }}</span>
                      </label>
                    </span>
                    <span class="inline-flex mr-2">
                      <label for="no" data-testid="edit-category-has-parent-no-label" class="inline-flex items-center cursor-pointer">
                        <p-radioButton data-testid="edit-category-has-parent-no" name="hasParentCategory" value="false" formControlName="hasParentCategory" inputId="no" />
                        <span for="no" class="ml-2">{{ 'BOOLEANS.NO' | translate }}</span>
                      </label>
                    </span>
                  </div>
                  <div class="field-wr flex flex-col col-12 col-sm-12 col-md-6 col-lg-6 col-xl-4 col-xxl-3" [ngClass]="{'disabled': categoryForm.get('hasParentCategory')?.value == 'false'}">
                    <label class="block text-sm" for="parentCategory">{{ 'CATEGORY_UPDATE.PARENT_CATEGORY' | translate }}</label>
                    <app-custom-dropdown
                      data-testid="parentcategory"
                      [placeholder]="'CATEGORY_UPDATE.SELECT_PARENT_PLACEHOLDER' | translate"
                      [fieldLabel]="'CATEGORY_UPDATE.PARENT_CATEGORY' | translate"
                      optionLabel="text"
                      optionValue="id"
                      [isMultiselect]="false"
                      [showSelectionChips]="true"
                      [showClear]="true"
                      [searchMode]="'remote'"
                      [pageSize]="categoriesRowsPerPageOption"
                      [totalCount]="categoriesTotalRecords"
                      [totalPages]="getTotalPages(categoriesTotalRecords, categoriesRowsPerPageOption)"
                      [options]="categoriesList"
                      formControlName="parentCategoryId"
                      (onLazyLoad)="onLazyLoadCategories($event)">
                    </app-custom-dropdown>
                    @if (categoryForm.errors?.['requiredCategory'] && isCategoryRequired()) {
                      <small data-testid="category-mandatory" class="p-error">{{ 'FORMS.MANDATORY_FIELD' | translate }}</small>
                    }
                  </div>
                </div>
                <div class="row">
                  <div class="col-12 mt-6 mb-4 pt-8 border-t">
                    <div class="flex items-center justify-end gap-3">
                      <button data-testid="edit-category-update-category-button" class="btn primary-btn" [disabled]="categoryForm.invalid" (click)="submitForm()">{{
                      'CATEGORY_UPDATE.BTN_UPDATE_CATEGORY' | translate }}</button>
                    </div>
                  </div>
                </div>
              </form>
              <!-- /main content -->
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
}
